export const NORMAL_FONT = "NORMAL_FONT";
export const normalFont = () => ({ type: NORMAL_FONT });

export const BIGGER_FONT = "BIGGER_FONT";
export const biggerFont = () => ({ type: BIGGER_FONT });

export const BIGGEST_FONT = "BIGGEST_FONT";
export const biggestFont = () => ({ type: BIGGEST_FONT });